import React from "react";
import PropTypes from "prop-types";
import { HamburgerIcon } from "../../../Icons";
import { ControlButtons, ControlTooltip } from "../../../ControlTooltip";

export function BoxTooltip(props) {
  const tooltipStyle = () => {
    let style = { position: "absolute", top: "-45px" };
    if (props.selected) {
      style = { top: "-65px" };
    }
    return style;
  };

  return (
    <ControlTooltip
      label="Box"
      showControls={props.selected}
      tooltipStyle={tooltipStyle()}
    >
      <ControlButtons buttonList={props.buttonList} />
    </ControlTooltip>
  );
}

BoxTooltip.propTypes = {
  /**
   * Boolean to set if plant is selected
   */
  selected: PropTypes.bool,
};

BoxTooltip.defaultProps = {
  buttonList: [
    {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClick: () => {},
      image: HamburgerIcon,
    },
  ],
};
